import type { FilePublicWithPermissions } from '@repo/types/files';

import CreateFSDir from '@/components/features/files/forms/CreateFSDir';
import DeleteFSEntry from '@/components/features/files/forms/DeleteFSEntry';
import DownloadFSEntry from '@/components/features/files/forms/DownloadFSEntry';
import EditFSEntryName from '@/components/features/files/forms/EditFSEntryName';
import InfoFSEntry from '@/components/features/files/forms/InfoFSEntry';
import MoveFSEntry from '@/components/features/files/forms/MoveFSEntry';
import ShareFSEntry from '@/components/features/files/forms/ShareFSEntry';
import FsMediaViewer from '@/components/features/files/layouts/files-page/FsMediaViewer';
import { useFilesStorage } from '@/store/files-store';

interface FilePageFormsProps {
  directoryId: string;
  files?: FilePublicWithPermissions[];
}

export default function FilePageForms(filePageFormsProps: FilePageFormsProps) {
  const { directoryId, files = [] } = filePageFormsProps;
  const {
    selected: elements,
    resetSelected,
    openDelete,
    openDownload,
    openEditName,
    openShare,
    openMove,
    openMoreInfo,
    openCreateDir,
    setOpenCreateDir,
    setOpenDelete,
    setOpenDownload,
    setOpenEditName,
    setOpenMoreInfo,
    setOpenMove,
    setOpenShare,
  } = useFilesStorage();

  return (
    <>
      <FsMediaViewer files={files} />
      <CreateFSDir parentDirId={directoryId} open={openCreateDir} onOpenChange={setOpenCreateDir} />
      <EditFSEntryName open={openEditName} onOpenChange={setOpenEditName} element={elements.directories[0] || elements.files[0]} directoryId={directoryId} />
      <InfoFSEntry open={openMoreInfo} onOpenChange={setOpenMoreInfo} element={elements.directories[0] || elements.files[0]} />
      <MoveFSEntry open={openMove} onOpenChange={setOpenMove} elements={elements} callback={resetSelected} directoryId={directoryId} />
      <DeleteFSEntry open={openDelete} onOpenChange={setOpenDelete} elements={elements} callback={resetSelected} directoryId={directoryId} />
      <DownloadFSEntry open={openDownload} onOpenChange={setOpenDownload} elements={elements} callback={resetSelected} />
      <ShareFSEntry
        open={openShare}
        onOpenChange={setOpenShare}
        element={elements.directories[0] || elements.files[0]}
        callback={() => {
          resetSelected();
          setOpenMoreInfo(false);
        }}
        directoryId={directoryId}
      />
    </>
  );
}
